/** Utilitários de máscara (formatação) — usados pelos campos de formulário. */

export function soDigitos(v: string): string {
  return (v || "").replace(/\D+/g, "");
}

export function mascararCpf(v: string): string {
  return soDigitos(v)
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function soAlfanumerico(v: string): string {
  return (v || "").replace(/[^0-9A-Za-z]+/g, "").toUpperCase();
}

/**
 * CNPJ alfanumérico (novo formato da Receita Federal, vigente a partir de 2026):
 * os 12 primeiros caracteres (raiz + ordem) podem ser letras ou números; os 2
 * dígitos verificadores finais continuam sendo sempre numéricos.
 */
export function mascararCnpj(v: string): string {
  const alfanum = soAlfanumerico(v).slice(0, 14);
  const corpo = alfanum.slice(0, 12);
  const dv = alfanum.slice(12, 14).replace(/[^0-9]/g, "");
  const raw = corpo + dv;

  let saida = "";
  for (let i = 0; i < raw.length; i++) {
    if (i === 2 || i === 5) saida += ".";
    else if (i === 8) saida += "/";
    else if (i === 12) saida += "-";
    saida += raw[i];
  }
  return saida;
}

/** Aplica CPF ou CNPJ automaticamente pelo tamanho (CNPJ agora aceita letras). */
export function mascararCpfCnpj(v: string): string {
  const alfanum = soAlfanumerico(v);
  const ehCnpj = /[A-Za-z]/.test(alfanum) || alfanum.length > 11;
  return ehCnpj ? mascararCnpj(v) : mascararCpf(v);
}

export function mascararRg(v: string): string {
  return (v || "").replace(/[^0-9A-Za-z.\-]/g, "").slice(0, 14);
}

/** Telefone fixo (10) ou celular/WhatsApp (11): (00) 0000-0000 / (00) 00000-0000 */
export function mascararTelefone(v: string): string {
  const d = soDigitos(v).slice(0, 11);
  if (d.length <= 10) {
    return d
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
  }
  return d
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
}

export function mascararCep(v: string): string {
  return soDigitos(v)
    .slice(0, 8)
    .replace(/(\d{5})(\d{1,3})$/, "$1-$2");
}

export function mascararData(v: string): string {
  return soDigitos(v)
    .slice(0, 8)
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2");
}

/** Moeda BRL a partir dos dígitos (centavos). Ex.: "12345" -> "123,45". */
export function mascararMoeda(v: string): string {
  const d = soDigitos(v);
  if (!d) return "";
  return (Number(d) / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function moedaParaNumero(v: string): number {
  const d = soDigitos(v);
  return d ? Number(d) / 100 : 0;
}

/** Inteiro com separador de milhar (sem casas decimais). Ex.: "20000" -> "20.000". */
export function mascararInteiroMilhar(v: string): string {
  const d = soDigitos(v);
  if (!d) return "";
  return Number(d).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
}

export function inteiroMilharParaNumero(v: string): number {
  const d = soDigitos(v);
  return d ? Number(d) : 0;
}
